import { render, staticRenderFns } from "./OrderVanCollapseContent.vue?vue&type=template&id=5da1be90&scoped=true"
import script from "./OrderVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./OrderVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./OrderVanCollapseContent.vue?vue&type=style&index=0&id=5da1be90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1be90",
  null
  
)

export default component.exports